export default function useNormalize(value) {
    return window.normalizer(value);
}